import { getTenant } from '../utils/sign-up';
import { reactive, ref } from 'vue';
import _ from 'lodash';
import { LoginMethod } from '../types/tenant';
import type { PostTenantSelectInfosItem, PostTenantSelectInfosParams } from '../types/tenant';
import type { CredentialResponse } from '../types/accounts';
import { updateTokenBaseRequestHeaders } from '@eureka/startup/src/enable-token-base'
import { useGoogleLogin } from './use-google-login';

/** 控制sign up弹框中 租户列表的显隐 */
const showMultiTenant = ref(false);

let tenants: PostTenantSelectInfosItem[] = reactive([]);
let googleCredential: CredentialResponse;

export function applyTenantIdInterceptor(
    tenantId: string,
    type: 'clear' | '' = ''
) {
    if (tenantId) {
        updateTokenBaseRequestHeaders({ 'X-Tenant-ID': tenantId })
    } else {
        updateTokenBaseRequestHeaders({ 'X-Tenant-ID': type === 'clear' ? '' : 'individual' })
    }
}

/** 格式化登录信息 */
function formatParamsByLoginType(
    params: { [key in string]: string },
    loginType: LoginMethod
) {
    let _params: PostTenantSelectInfosParams = {};
    if (loginType === LoginMethod.google) {
        _params = {
            google_id_token: params.google_id_token,
        };
    }
    return {
        ..._params,
        login_method_enum: loginType,
    };
}

async function getTenants(
    params: { [key in string]: string },
    loginType: LoginMethod
) {
    const _params = formatParamsByLoginType(params, loginType);
    let tenants = await getTenant(_params);
    tenants = _.map(tenants, (item) => {
        if (item.individual) {
            item.tenant_name = 'Sign in as an individual'
        }
        return item;
    });
    return tenants;
}

function getDefaultTenant(tenants: PostTenantSelectInfosItem[]) {
    const defaultTenant = _.find(tenants, (tenant) => {
        return (
            tenant.default_selected &&
            !tenant.domain_restrict &&
            !tenant.ip_restrict &&
            !tenant.sso_restrict
        );
    });
    return defaultTenant as PostTenantSelectInfosItem;
}

export function useTenant() {
    /** 获取租户列表 */
    async function getTenantList(response: CredentialResponse) {
        googleCredential = response;
        if (!googleCredential.credential) return true;
        try {
            // 多租户判断
            applyTenantIdInterceptor('', 'clear');
            tenants = [];
            const arr = await getTenants(
                {
                    google_id_token: googleCredential.credential,
                },
                LoginMethod.google
            );
            tenants.push(...arr);
            if (!tenants.length) {
                showMultiTenant.value = false;
                return true;
            }
            const defaultTenant = getDefaultTenant(tenants);
            if (!_.isEmpty(defaultTenant)) {
                applyTenantIdInterceptor(defaultTenant.tenant_id);
                return true;
            } else {
                showMultiTenant.value = true;
            }
            return false;
        } catch (error) {
            tenants = [];
            showMultiTenant.value = false;
            return Promise.reject(error);
        }
    }

    function onClose() {
        showMultiTenant.value = false;
    }

    function onSelect(data: PostTenantSelectInfosItem) {
        const { handleOnSuccess } = useGoogleLogin();
        onClose();
        if (_.isEmpty(data)) return;
        applyTenantIdInterceptor(data.tenant_id);
        handleOnSuccess(googleCredential, false);
    }

    return {
        tenants,
        showMultiTenant,
        getTenantList,
        onSelect,
        onClose,
    };
}
